import { __awaiter } from "tslib";
import { setCurrencies, setCurrenciesReadyState, } from "../reducers/Additional/currenciesReducer";
import { getCurrenciesState } from "../reducers/selectors";
import { FetchReadyState } from "../types/ReadyState";
export function fetchCurrencies() {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        const currencies = getCurrenciesState(getState());
        // skip if already loaded
        if (currencies.readyState !== FetchReadyState.Initial) {
            return;
        }
        try {
            dispatch(setCurrenciesReadyState(FetchReadyState.Fetching));
            const response = yield cfgApi.getCurrencies({});
            dispatch(setCurrencies(response));
            dispatch(setCurrenciesReadyState(FetchReadyState.Ready));
        }
        catch (_err) {
            dispatch(setCurrenciesReadyState(FetchReadyState.Error));
        }
    });
}
//# sourceMappingURL=fetchCurrencies.js.map